import type { SportConfig } from '../types/sport';

export const beachVolleyballConfig: SportConfig = {
  id: 'beach_volleyball',
  name: { ru: 'Пляжный волейбол', en: 'Beach Volleyball' },
  icon: 'beach_volleyball',
  color: '#FBBF24',
  defaults: {
    teamMode: '2_teams',
    scoringMode: 'sets',
    maxParticipants: 6,
    durationMinutes: 90,
    teamsCount: 2,
    hasParticipantLimit: true,
    participantStep: 2,
  },
  scoring: {
    type: 'sets',
    labels: { ru: ['Команда А', 'Команда Б'], en: ['Team A', 'Team B'] },
  },
  shuffle: {
    enabled: true,
    modes: ['ai', 'snake_draft'],
    factors: ['rating', 'recent_form', 'reliability', 'experience', 'mvp_count'],
  },
  ratings: { enabled: true, scale: { min: 1, max: 5 }, anonymous: true },
  // 2v2 — "MVP of your team" degenerates to "the other player". Disabled.
  mvp: { enabled: false, perTeam: false },
  positions: null,
  supportsMultiMatch: false,
  playersPerTeam: 2,
};
